import { useTranslation } from 'react-i18next'
import { v4 as uuidv4 } from 'uuid'
import { Table, TableBody, Box, TableContainer, alpha } from '@mui/material'

import { colors } from '@/theme/colors.theme'
import PaginationTable from '@/views/components/pagination-table/index.component'
import SkeletonLoader from '@/views/components/skeleton'

import NoContentAvailable from '@/views/components/no-content-available/index.component'
import { usePersonalizationEngineTable } from '@/views/personalization-engine/hooks'
import {
  FavoriteGamesTableHeadComponent,
  FavoriteGamesTableRowComponent,
} from './'

export const FavoriteGamesTableComponent = () => {
  const { t } = useTranslation()

  const {
    handleChangePage,
    handleChangeLimit,
    createSortHandler,
    sortedRows,
    order,
    orderBy,
    headCells,
    isLoadingFavoriteGames,
    pagination,
  } = usePersonalizationEngineTable()

  return (
    <>
      <TableContainer>
        <Table aria-label="favorite-games">
          <FavoriteGamesTableHeadComponent
            order={order}
            orderBy={orderBy}
            createSortHandler={createSortHandler}
            headCells={headCells}
          />
          <TableBody>
            {!isLoadingFavoriteGames &&
              sortedRows.length > 0 &&
              sortedRows.map((row) => (
                <FavoriteGamesTableRowComponent key={uuidv4()} row={row} />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      {isLoadingFavoriteGames ? (
        <SkeletonLoader element="table" />
      ) : (
        <>
          {sortedRows.length !== 0 ? (
            <PaginationTable
              pagination={pagination}
              handleChangePage={handleChangePage}
              handleChangeLimit={handleChangeLimit}
            />
          ) : (
            <Box
              display="flex"
              flexDirection="column"
              flexGrow={1}
              justifyContent="center"
              border={1}
              borderColor={alpha(colors.white, 0.3)}
              py={5}
            >
              <NoContentAvailable
                title={t('messages.noData')}
                instruction={t('messages.noResultsFound')}
                subInstruction={t('messages.tryRemovingFilters')}
              />
            </Box>
          )}
        </>
      )}
    </>
  )
}
